import React from 'react';

// DEPENDENCIES
import clsx from 'clsx';

// GLOBAL VARIABLES
import { ENDPOINTS } from 'endpoints';

// GLOBAL FUNCTIONS
import { makePath } from 'functions';

// TOOLS
import ViewPDFLink from 'routers/interface/tools/ViewPDFLink';

// MAIN COMPONENT
const RebateAttachments = ({
  as: Component = 'div',
  className,
  cell: { column: { id: key } = {} } = {},
  row: {
    original: {
      dealer_rebate_id, //
      documentAttachment = {}
    }
  } = {},
  placeholder,
  ...props
}) => {
  return (
    <Component className={clsx('flex-column align-items-center justify-content-center', className)} {...props}>
      {!!documentAttachment[key]?.length
        ? documentAttachment[key].map(({ rebateattachment_id, rebateattachment_filename }, i) => (
            <ViewPDFLink
              key={i}
              endpoint={makePath(ENDPOINTS.uploads.rebate.view(dealer_rebate_id), rebateattachment_id)}
              fileName={rebateattachment_filename}
            />
          ))
        : placeholder}
    </Component>
  );
};

// EXPORT
export default RebateAttachments;
